module.exports = __webpack_public_path__ + "img/case72.ce0891b2.png";